import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock-in-stop-filled",
  "use": "clock-in-stop-filled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"clock-in-stop-filled\"><circle cx=\"8\" cy=\"8\" r=\"8\" /><path fill=\"#fff\" d=\"M5 5h6v6H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol